import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/web.timers.js';
import { __awaiter } from 'tslib';
import { DB_NAME } from '@tencent/ark-model';
import LoggerPlugin from '@tencent/memoire-plugin-logger';
import StructuredStorage from '@tencent/memoire-structured-storage';
export { SortOrder } from '@tencent/memoire-structured-storage';
import MonitorPlugin from '@tencent/memoire-plugin-monitor';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import IDBEngine from '@tencent/memoire-idb-engine';
import NativeEngine from '@tencent/memoire-native-engine';
import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.number.min-safe-integer.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.number.max-safe-integer.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.map.js';

var DATABASE_SCHEMA = '{"name":"unknown","collections":[{"name":"DocumentData","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"subGlobalPadId","path":"subGlobalPadId","unique":false},{"name":"subDocType","path":"subDocType","unique":false},{"name":"version","path":"version","unique":false},{"name":"type","path":"type","unique":false},{"name":"uid","path":"uid","unique":false},{"name":"subId","path":"subSheetId","unique":false},{"name":"chunkId","path":"chunkId","unique":false}],"properties":["key","secretId","globalPadId","subGlobalPadId","subDocType","version","type","uid","subId","chunkId","taskId","data","docType","docStatus","createTimestamp","lastModifyTimestamp","dataVersion","isDefaultChunk"]},{"name":"DocumentEntities","key":{"path":"key"},"indices":[],"properties":["key","data"]},{"name":"NewDocumentIds","key":{"path":"globalPadId"},"indices":[],"properties":["globalPadId","secretId","documentType","localPadId","isCreated"]},{"name":"DocumentStatus","key":{"path":"globalPadId"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"uid","path":"uid","unique":false}],"properties":["globalPadId","secretId","uid","lastSyncTimestamp","lastErrorTimestamp"]},{"name":"DriveData","key":{"path":"driveId"},"indices":[{"name":"fileId","path":"fileId","unique":false},{"name":"objKey","path":"objKey","unique":false},{"name":"secretId","path":"secretId","unique":false},{"name":"uid","path":"uid","unique":false}],"properties":["driveId","fileId","objKey","secretId","uid","type","lastRequestTime","fileInfo","previewInfo"]},{"name":"OfflineData","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"subGlobalPadId","path":"subGlobalPadId","unique":false},{"name":"subDocType","path":"subDocType","unique":false},{"name":"version","path":"version","unique":false},{"name":"type","path":"type","unique":false},{"name":"uid","path":"uid","unique":false},{"name":"subId","path":"subSheetId","unique":false},{"name":"chunkId","path":"chunkId","unique":false}],"properties":["key","secretId","globalPadId","subGlobalPadId","subDocType","version","type","uid","subId","chunkId","taskId","data","docType","docStatus","createTimestamp","lastModifyTimestamp","dataVersion","isDefaultChunk"]},{"name":"PadInfo","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"uid","path":"uid","unique":false}],"properties":["key","secretId","globalPadId","uid","addListTimestamp","attribute","childrenLength","clientVersion","createTimestamp","creator","creatorDomain","icon","docPolicy","docPrivilege","thumbnail","docType","docTypeDesc","url","domainId","dver","folder","folderId","folderPolicy","folderPrivilege","isDeleted","isManualOffline","isMyCreated","isMydoc","isOfflineCache","isRencent","isShareToMe","hasSnapShot","isStar","isAddedToMy","isCollected","isOwner","isPinned","isShortcut","isUserChangeTitle","lastSyncTimestamp","lastBrowseTimestamp","lastCollectTimestamp","lastDeleteTimestamp","lastModifyTimestamp","lastModifyNick","lastModifyUid","lastPinnedTimestamp","listInfoType","listType","offlineCommiting","offlineCommitSuccessd","originFolderId","ownerNick","ownerUid","padId","parentFolderId","parents","privilege","status","title","type","hasLocalChanges","docSubType","officialAuthInfo","personalizeInfo","nativeEngineStatusRecord","nativeEngineDocPrivilege","data","ext","isOfflineCacheByNative","mimeType","ownerVipInfo","documentResourceCacheStatus","cacheStatus","cacheStatusTs"]},{"name":"Users","key":{"path":"key"},"indices":[{"name":"tinyId","path":"tinyId","unique":false},{"name":"nowUserIndex","path":"nowUserIndex","unique":false},{"name":"docId","path":"docId","unique":false},{"name":"pageType","path":"pageType","unique":false},{"name":"wedriveUin","path":"wedriveUin","unique":false},{"name":"wedocOpenId","path":"wedocOpenId","unique":false}],"properties":["key","tinyId","nowUserIndex","docId","pageType","wedriveUin","wedocOpenId","corpId","corpName","englishName","loginType","openId","uidSource","uin","userId","userName","userPic","updateTime","settings","bindUserInfo","vipUserInfo"]}]}';

var STORAGE_MONITOR_EVENT = 'storageActionResultAndCost';
function getMonitorPlugin(monitorReporter) {
  var plugin = new MonitorPlugin({
    onEvent: function onEvent(event) {
      monitorReporter.report(STORAGE_MONITOR_EVENT, {
        action: event.action,
        module: event.module,
        retCode: event.actionExecuteState,
        cost: event.cost,
        time: event.time.getTime(),
        errorMsg: event.errorMsg
      });
    }
  });
  return plugin;
}

var _dbEngineGenerator;
/**
 * 数据库的当前版本
 */
var databaseVersion = 5;
/**
 * 数据库初始化默认超时
 */
var defaultTimeout = 15 * 1000;
var DBEngineType;
(function (DBEngineType) {
  DBEngineType[DBEngineType["indexDB"] = 1] = "indexDB";
  DBEngineType[DBEngineType["nativeDB"] = 2] = "nativeDB";
})(DBEngineType || (DBEngineType = {}));
var dbEngineGenerator = (_dbEngineGenerator = {}, _defineProperty(_dbEngineGenerator, DBEngineType.indexDB, IDBEngine), _defineProperty(_dbEngineGenerator, DBEngineType.nativeDB, NativeEngine), _dbEngineGenerator);

var StorageManager = /*#__PURE__*/function () {
  function StorageManager() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      type: DBEngineType.indexDB,
      disableAutoOpen: true
    };
    _classCallCheck(this, StorageManager);
    var _a;
    this.config = config;
    var DBEngineGenerator = dbEngineGenerator[config.type];
    this.storage = new StructuredStorage({
      name: (_a = config.databaseName) !== null && _a !== void 0 ? _a : DB_NAME,
      version: databaseVersion,
      engine: new DBEngineGenerator(),
      databaseSchema: DATABASE_SCHEMA,
      disableAutoOpen: config.disableAutoOpen,
      plugins: this.getPlugins(config),
      supportCompatibleOpen: true
    });
  }
  _createClass(StorageManager, [{
    key: "dispose",
    value: function dispose() {
      this.storage.close();
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                var _a;
                // 超时未完成初始化
                var timeoutId = setTimeout(function () {
                  var _a, _b;
                  (_b = (_a = _this.config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'dababase init timeout.');
                  resolve(false);
                }, (_a = _this.config.timeout) !== null && _a !== void 0 ? _a : defaultTimeout);
                _this.storage.open().then(function () {
                  resolve(true);
                  clearTimeout(timeoutId);
                })["catch"](function () {
                  resolve(false);
                  clearTimeout(timeoutId);
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "getPlugins",
    value: function getPlugins(config) {
      var plugins = [];
      if (config.logger) {
        var logger = new LoggerPlugin({
          logger: config.logger,
          disabled: !!config.disabled,
          verbose: !!config.verbose
        });
        plugins.push(logger);
      }
      if (config.monitorReporter) {
        plugins.push(getMonitorPlugin(config.monitorReporter));
      }
      return plugins;
    }
  }]);
  return StorageManager;
}();

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DB_NAME_BACKUP = 'TencentDocsBackup';
var StorageBackupManager = /*#__PURE__*/function (_StorageManager) {
  _inherits(StorageBackupManager, _StorageManager);
  var _super = _createSuper$1(StorageBackupManager);
  function StorageBackupManager() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      type: DBEngineType.indexDB,
      disableAutoOpen: true
    };
    _classCallCheck(this, StorageBackupManager);
    _this = _super.call(this, config);
    _this.config = config;
    return _this;
  }
  return _createClass(StorageBackupManager);
}(StorageManager);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ChangeStorage = /*#__PURE__*/function () {
  function ChangeStorage(collection) {
    _classCallCheck(this, ChangeStorage);
    this.collection = collection;
  }
  _createClass(ChangeStorage, [{
    key: "getChanges",
    value: function getChanges(storageOption, queryOption) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var query;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = this.collection.where({
                uid: storageOption.uid,
                secretId: storageOption.secretId,
                subGlobalPadId: storageOption.subGlobalPadId,
                subDocType: {
                  "in": storageOption.subDocType
                },
                type: {
                  "in": storageOption.types
                },
                docType: storageOption.docType,
                dataVersion: storageOption.dataVersion,
                subId: {
                  "in": storageOption.subId ? new Array().concat(storageOption.subId) : undefined
                },
                chunkId: {
                  "in": storageOption.chunkId ? new Array().concat(storageOption.chunkId) : undefined
                },
                version: {
                  '>=': queryOption === null || queryOption === void 0 ? void 0 : queryOption.startVersion,
                  '<=': queryOption === null || queryOption === void 0 ? void 0 : queryOption.endVersion
                }
              });
              if (queryOption === null || queryOption === void 0 ? void 0 : queryOption.orderPath) {
                query.orderBy(queryOption.orderPath, queryOption.sortOrder);
              }
              if (queryOption === null || queryOption === void 0 ? void 0 : queryOption.limit) {
                query.take(queryOption.limit);
              }
              return _context.abrupt("return", query.values());
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "upsertChanges",
    value: function upsertChanges(changes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.collection.bulkUpsert(changes);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "deleteChanges",
    value: function deleteChanges(option) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var uid, secretId, globalPadId, types, taskIds, subGlobalPadId, subDocType;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              uid = option.uid, secretId = option.secretId, globalPadId = option.globalPadId, types = option.types, taskIds = option.taskIds, subGlobalPadId = option.subGlobalPadId, subDocType = option.subDocType;
              _context3.next = 3;
              return this.collection.where({
                uid: uid,
                secretId: secretId,
                globalPadId: globalPadId,
                subGlobalPadId: subGlobalPadId,
                subDocType: {
                  "in": subDocType
                },
                type: {
                  "in": types
                },
                taskId: {
                  "in": taskIds
                },
                version: {
                  '>': option.startVersion || Number.MIN_SAFE_INTEGER,
                  '<': option.endVersion || Number.MAX_SAFE_INTEGER
                }
              }).clear();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return ChangeStorage;
}();
var DocumentDataStorage = /*#__PURE__*/function (_ChangeStorage) {
  _inherits(DocumentDataStorage, _ChangeStorage);
  var _super = _createSuper(DocumentDataStorage);
  function DocumentDataStorage() {
    _classCallCheck(this, DocumentDataStorage);
    return _super.apply(this, arguments);
  }
  return _createClass(DocumentDataStorage);
}(ChangeStorage);
var OfflineDataStorage = /*#__PURE__*/function (_ChangeStorage2) {
  _inherits(OfflineDataStorage, _ChangeStorage2);
  var _super2 = _createSuper(OfflineDataStorage);
  function OfflineDataStorage() {
    _classCallCheck(this, OfflineDataStorage);
    return _super2.apply(this, arguments);
  }
  return _createClass(OfflineDataStorage);
}(ChangeStorage);

/**
 * 预拉取的文档 ID 表相关存取接口
 * 注意：所有数据库操作都可能面临异常情况
 * 与 bingo 确认后，确定将错误直接抛出到外层，由外层统一处理
 */
var DocumentIdStorage = /*#__PURE__*/function () {
  function DocumentIdStorage(collection) {
    _classCallCheck(this, DocumentIdStorage);
    this.collection = collection;
  }
  /**
   * 取出一个有效的 DoumentId，同时将从数据库中删除该条记录
   * @return DocumentId 对象，如果没有记录则返回 null
   */
  _createClass(DocumentIdStorage, [{
    key: "popDocumentId",
    value: function popDocumentId(documentType) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var documentIdModelValue, key, deleteKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.collection.where({
                documentType: documentType
              }).first();
            case 2:
              documentIdModelValue = _context.sent;
              if (documentIdModelValue) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", null);
            case 5:
              // 删除之后再返回
              key = documentIdModelValue.globalPadId;
              _context.next = 8;
              return this.collection["delete"](key);
            case 8:
              deleteKey = _context.sent;
              if (!(key !== deleteKey)) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", null);
            case 11:
              return _context.abrupt("return", documentIdModelValue);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 插入多个 DocumentId 记录，如果记录不存在则会插入新纪录
     * @param ids DocumentId 对象数组
     */
  }, {
    key: "upsertDocumentIds",
    value: function upsertDocumentIds(ids) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.collection.bulkUpsert(ids);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 查询所有 DocumentId 记录
     */
  }, {
    key: "countDocumentIds",
    value: function countDocumentIds(documentType) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.collection.where({
                documentType: documentType
              }).count());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * 删除所有的DocumentId对象
     */
  }, {
    key: "deleteDocumentIds",
    value: function deleteDocumentIds() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.collection.clear();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }]);
  return DocumentIdStorage;
}();

var DocumentStatusStorage = /*#__PURE__*/function () {
  function DocumentStatusStorage(collection) {
    _classCallCheck(this, DocumentStatusStorage);
    this.collection = collection;
  }
  /**
   * 查询指定用户指定文档的同步状态记录
   */
  _createClass(DocumentStatusStorage, [{
    key: "getStatus",
    value: function getStatus(uid, secretId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var entity;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.collection.where({
                secretId: secretId,
                uid: uid
              }).first();
            case 2:
              entity = _context.sent;
              return _context.abrupt("return", entity);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 更新同步状态记录
     */
  }, {
    key: "upsertStatus",
    value: function upsertStatus(status) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.collection.upsert(status);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 删除指定用户指定文档的同步状态记录
     */
  }, {
    key: "deleteStatus",
    value: function deleteStatus(uid, secretId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.collection.where({
                secretId: secretId,
                uid: uid
              }).clear();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return DocumentStatusStorage;
}();

var DocumentEntityStorage = /*#__PURE__*/function () {
  function DocumentEntityStorage(collection) {
    _classCallCheck(this, DocumentEntityStorage);
    this.collection = collection;
  }
  /**
   * 查询指定扩展数据实体
   *
   * @template T
   * @param {string} key 查询的扩展数据实体key
   * @return {*}  {(Promise<DocumentEntity<T> | null>)}
   * @memberof DocumentEntityStorage
   */
  _createClass(DocumentEntityStorage, [{
    key: "getEntity",
    value: function getEntity(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var entity;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.collection.get(key);
            case 2:
              entity = _context.sent;
              return _context.abrupt("return", entity);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 批量更新扩展实体
     *
     * @template T
     * @param {DocumentEntity<T>[]} entities
     * @return {*}  {Promise<void>}
     * @memberof DocumentEntityStorage
     */
  }, {
    key: "upsertEntities",
    value: function upsertEntities(entities) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.collection.bulkUpsert(entities);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 删除指定key的扩展数据实体
     *
     * @param {string} key 要删除的扩展数据实体key
     * @return {*}  {Promise<void>}
     * @memberof DocumentEntityStorage
     */
  }, {
    key: "deleteEntity",
    value: function deleteEntity(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.collection["delete"](key);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return DocumentEntityStorage;
}();

/**
 * 文档基础信息表 PadInfo 基础操作 API 封装
 */
var PadInfoStorage = /*#__PURE__*/function () {
  function PadInfoStorage(collection) {
    _classCallCheck(this, PadInfoStorage);
    this.collection = collection;
  }
  /**
   * 根据指定 ID 查询文档 PadInfo 信息
   * @param uid 用户 id
   * @param secretId 文档加密 id
   */
  _createClass(PadInfoStorage, [{
    key: "getPadInfo",
    value: function getPadInfo(uid, secretId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var padInfos;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getPadInfos({
                uid: uid,
                secretId: secretId
              });
            case 2:
              padInfos = _context.sent;
              if (!(padInfos.length === 0)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", null);
            case 5:
              return _context.abrupt("return", padInfos.shift());
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 查询符合指定条件的文档 PadInfo 信息
     * @param queryOption 查询条件
     */
  }, {
    key: "getPadInfos",
    value: function getPadInfos(queryOption) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var query;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = this.collection.where({
                uid: queryOption.uid,
                secretId: {
                  "in": queryOption.secretId ? new Array().concat(queryOption.secretId) : undefined
                }
              });
              return _context2.abrupt("return", query.values());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 更新文档 PadInfo 信息（全量更新接口）
     * @param padInfo 文档 PadInfo 信息
     */
  }, {
    key: "upsertPadInfo",
    value: function upsertPadInfo(padInfo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.collection.upsert(padInfo);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * 更新 PadInfo 指定字段值
     * @param uid 用户 id
     * @param secretId 文档加密 id
     * @param deltaFields 待更新的字段和值
     */
  }, {
    key: "updateField",
    value: function updateField(uid, secretId, deltaFields) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var padInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.collection.where({
                uid: uid,
                secretId: secretId
              }).first();
            case 2:
              padInfo = _context4.sent;
              if (padInfo) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return");
            case 5:
              Object.assign(padInfo, deltaFields);
              _context4.next = 8;
              return this.collection.upsert(padInfo);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
    /**
     * 删除指定文档的 PadInfo 信息
     * @param uid 用户id
     * @param secretId 文档加密 id
     */
  }, {
    key: "deletePadInfo",
    value: function deletePadInfo(uid, secretId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.collection.where({
                uid: uid,
                secretId: secretId
              }).clear();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }]);
  return PadInfoStorage;
}();

var UserInfoStorage = /*#__PURE__*/function () {
  function UserInfoStorage(collection) {
    _classCallCheck(this, UserInfoStorage);
    this.collection = collection;
  }
  _createClass(UserInfoStorage, [{
    key: "getUserInfoByTinyId",
    value: function getUserInfoByTinyId(tinyId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.collection.where({
                tinyId: tinyId
              }).last();
            case 2:
              userInfo = _context.sent;
              if (!userInfo) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", userInfo);
            case 5:
              return _context.abrupt("return", null);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getUserInfoByNowUserIndex",
    value: function getUserInfoByNowUserIndex(nowUserIndex) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.collection.where({
                nowUserIndex: nowUserIndex
              }).last();
            case 2:
              userInfo = _context2.sent;
              if (!userInfo) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", userInfo);
            case 5:
              return _context2.abrupt("return", this.getUserInfoLastByAll());
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getUserInfoByDocInfo",
    value: function getUserInfoByDocInfo(pageType, docId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.collection.where({
                pageType: pageType,
                docId: docId
              }).last();
            case 2:
              userInfo = _context3.sent;
              if (!userInfo) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", userInfo);
            case 5:
              return _context3.abrupt("return", this.getUserInfoLastByAll());
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "addUserInfo",
    value: function addUserInfo(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var user;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.collection.get(data.key);
            case 3:
              user = _context4.sent;
              this.collection.upsert(Object.assign(Object.assign({}, user), data));
              return _context4.abrupt("return", true);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 8]]);
      }));
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo(param, deltaFields) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var userList, upsertList;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.collection.where(param).values();
            case 3:
              userList = _context5.sent;
              if (!(userList.length === 0)) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return", false);
            case 6:
              upsertList = userList.map(function (item) {
                return Object.assign(Object.assign({}, item), deltaFields);
              });
              _context5.next = 9;
              return this.collection.bulkUpsert(upsertList);
            case 9:
              return _context5.abrupt("return", true);
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", false);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 12]]);
      }));
    }
  }, {
    key: "getUserInfoLastByAll",
    value: function getUserInfoLastByAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.collection.last();
            case 2:
              userInfo = _context6.sent;
              return _context6.abrupt("return", userInfo);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }]);
  return UserInfoStorage;
}();

/**
 * 文档基础信息表 PadInfo 基础操作 API 封装
 */
var DriveDataStorage = /*#__PURE__*/function () {
  function DriveDataStorage(collection) {
    _classCallCheck(this, DriveDataStorage);
    this.collection = collection;
  }
  /**
   * 根据指定ID和objkey组成的唯一id查driveData
   * @param options IOptions
   */
  _createClass(DriveDataStorage, [{
    key: "getDriveData",
    value: function getDriveData(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.collection.where(Object.assign({}, options)).first());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getDriveDatas",
    value: function getDriveDatas(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.collection.where(Object.assign({}, options)).values());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 插入新的driveData数据
     * @param driveDatas drive文件信息
     */
  }, {
    key: "insertDriveDatas",
    value: function insertDriveDatas(driveDatas) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.collection.bulkUpsert(driveDatas);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * 根据指定ID和objkey组成的唯一id查driveData
     * @param options IOptions
     */
  }, {
    key: "deleteDriveDatas",
    value: function deleteDriveDatas(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.collection.where(Object.assign({}, options)).clear();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }]);
  return DriveDataStorage;
}();

export { DBEngineType, DB_NAME_BACKUP, DocumentDataStorage, DocumentEntityStorage, DocumentIdStorage, DocumentStatusStorage, DriveDataStorage, OfflineDataStorage, PadInfoStorage, StorageBackupManager, StorageManager, UserInfoStorage };
//# sourceMappingURL=index.js.map
